import { cmsCLient } from '@/services/axiosConfig'
import { GetCityList, GetDistrictList, GetHbbWifi, GetQuarterList, GetTravelPoint } from './types'

export const getCityList: GetCityList = async () => {
  try {
    const response = await cmsCLient.get('/city/list', {})
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}

export const getDistrictList: GetDistrictList = async (params) => {
  try {
    const response = await cmsCLient.get('/district/list', { params })
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}

export const getQuarterList: GetQuarterList = async (params) => {
  try {
    const response = await cmsCLient.get('/horoo/list', { params })
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}

export const getTravelPoint: GetTravelPoint = async (params) => {
  try {
    const response = await cmsCLient.get('/travel-point/list', { params })
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}

export const getHbbWifi: GetHbbWifi = async () => {
  try {
    const response = await cmsCLient.get('/travel-point/list')
    return response.data.data
  } catch (e: any) {
    return e.message
  }
}
